import { QuestionProductScanItemComponent } from './question-product-scan-item.component';

export default angular
  .module('sfMobile.components.product-scan-item', [])
  .component('sfProductScanItem', QuestionProductScanItemComponent).name;
